import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "./pages/LandingPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            borderRadius: 0,
            border: "2px solid #0B1C14",
            background: "#F4F3EF",
            color: "#0B1C14",
            fontFamily: "'Manrope', sans-serif",
            fontWeight: 600,
          },
        }}
      />
    </div>
  );
}

export default App;
